import * as React from "react";
const DateSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4,4 L6,4 L6,3 L7,3 L7,4 L11,4 L11,3 L12,3 L12,4 L14,4 C14.5522847,4 15,4.44771525 15,5 L15,14 C15,14.5522847 14.5522847,15 14,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,5 C3,4.44771525 3.44771525,4 4,4 Z M4,5 L4,7 L14,7 L14,5 L12,5 L12,6 L11,6 L11,5 L7,5 L7,6 L6,6 L6,5 L4,5 Z M4,8 L4,14 L14,14 L14,8 L4,8 Z" }));
DateSmall.displayName = "DateSmall";
var DateSmall_default = DateSmall;
export {
  DateSmall_default as default
};
